/**
 * Fotoğraf galerileri — kapak, başlık, fotoğraf sayısı.
 * Üretimde kapak görselleri ve albüm URL’lerini güncelleyin.
 *
 * @typedef {{
 *   id: string,
 *   slug: string,
 *   title: string,
 *   photoCount: number,
 *   coverImageSrc: string,
 *   createdAt?: string,
 *   eventId?: string,
 *   meetingId?: string,
 * }} GalleryAlbum
 */

/** @type {GalleryAlbum[]} */
export const GALLERIES = [
    {
        id: '1',
        slug: 'prof-dr-ustun-erguder-konusmacimizdi',
        title: 'Prof. Dr. Üstün Ergüder konuşmacımızdı',
        photoCount: 24,
        coverImageSrc: '/assets/images/gallery-cover-placeholder.svg',
    },
    {
        id: '2',
        slug: 'bodrum-ladies-night-18',
        title: "18. Bodrum Ladies' Night organizasyonumuzu…",
        photoCount: 24,
        coverImageSrc: '/assets/images/gallery-cover-placeholder.svg',
    },
    {
        id: '3',
        slug: 'ornek-galeri-3',
        title: 'Kulüp toplantısı — aralık ayı',
        photoCount: 18,
        coverImageSrc: '/assets/images/gallery-cover-placeholder.svg',
    },
    {
        id: '4',
        slug: 'ornek-galeri-4',
        title: 'Sosyal sorumluluk projesi saha ziyareti',
        photoCount: 32,
        coverImageSrc: '/assets/images/gallery-cover-placeholder.svg',
    },
];

/**
 * @param {string | undefined} slug
 * @returns {GalleryAlbum | undefined}
 */
export function getGalleryBySlug(slug) {
    if (!slug) return undefined;
    return GALLERIES.find((g) => g.slug === slug);
}
